







import { computed, defineComponent } from '@vue/composition-api';

export default defineComponent({
  name: 'Scanner',
  props: {
    viewWidth: { type: String, default: '50vw' },
    bgZIndex: { type: Number, default: -1 },
    bgEnabled: { type: Boolean, default: true },
    bgColor: { type: String, default: 'rgba(0,0,0,0.5)' },
    bgBlur: { type: String, default: '0.5vw' },
    borderZIndex: { type: Number, default: 0},
    borderEnabled: { type: Boolean, default: true },
    borderColor: { type: String, default: '#fff' },
    borderWidth: { type: String, default: '0.25vw' },
  },
  setup(props) {
    const cssVars = computed(() => ({
      '--viewWidth': props.viewWidth,
      '--bgZIndex': props.bgZIndex,
      '--bgColor': props.bgColor,
      '--bgBlur': props.bgBlur,
      '--borderZIndex': props.borderZIndex,
      '--borderColor': props.borderColor,
      '--borderWidth': props.borderWidth
    }));

    return {
      cssVars
    }
  }
});
